// FAQリスト
export const faqList = [
  {
    cate: 'コンサルティングセッション',
    q: '専属コンサルタントは1名でしょうか？',
    a: `基本的に、1名のコンサルタントが全てのトレーニングを担当します。ただし、担当コンサルタントの年次休暇などの都合により、その他のコンサルタントが担当させていただく場合がございます。`
  },
  {
    cate: 'コンサルティングセッション',
    q: '今後のコンサルティングセッションの実施日時を変更したいのですが、可能ですか？',
    a: `コンサルタントのセッションスケジュールの空き次第となりますので、担当コンサルタントに一度ご相談ください。<br />日時を変更する場合には担当のコンサルタントも変更となる可能性がございますので、予めご了承ください。`
  },
  {
    cate: 'コンサルティングセッション（欠席・振替）',
    q: 'コンサルティングセッションを欠席する場合、いつまでに、どこへ連絡すれば良いでしょうか？',
    a: `コンサルティングセッションの欠席・振替をご希望の場合は、お手数ですが LINE にてご連絡ください。<br />セッション前日の22: 00までにご連絡いただけましたら、お振替が可能です。それ以降にご連絡いただいた場合、お振替することができませんのでご注意ください。`
  },
  {
    cate: 'コンサルティングセッション（欠席・振替）',
    q: '振替をしたセッションの再振替は可能？',
    a: 'お振替は月1回のみ可能です。再振替はいたしかねますので、予めご了承ください。'
  },
  {
    cate: 'コンサルティングセッション（欠席・振替）',
    q: '日時の振替をしたコンサルティングセッションの担当は専属コンサルタントですか？',
    a: `お振替の場合には代講となる可能性がございますので、予めご了承ください。<br />その際も、責任をもって引き継ぎが行われますのでご安心くださいませ。`
  },
  {
    ccate: 'アセスメントテスト／アセスメント模試',
    q: 'アセスメントテスト／アセスメント模試はどの冊子に取り組めば良いでしょうか？',
    a: `メールやStudyplusにてお送りするコンサルティングレポートに、担当コンサルタントからの案内がございますのでご確認ください。<br />
        ご成長やタイミングにあわせて、どの模試、どの冊子にお取り組みいただくかはカスタマイズして指定いたします。`
  },
  {
    cate: 'アセスメントテスト／アセスメント模試',
    q: 'アセスメントテスト／アセスメント模試はいつ取り組めば良いでしょうか？',
    a: `基本的にはセッション当日の、セッション開始時刻までにお取り組みください。<br />
        当日の実施が難しい場合には前日にお取り組みいただいでも構いません。`
  },
  {
    cate: 'アセスメントテスト／アセスメント模試',
    q: 'アセスメントテスト／アセスメント模試の結果はどのように共有すれば良いでしょうか？',
    a: '丸付けまでお済みになりましたら、携帯機器で写真を撮り、その画像データをStudyplusにてご共有ください。'
  },
  {
    cate: 'オンライン英会話サービス',
    q: 'オンライン英会話サービスを併用して、そちらについてのコンサルティングもお願いしたいのですが、まずどのサービスを選べば良いでしょうか？',
    a: '課題や活用目的、現実的な活用頻度などをふまえて最適な選択肢をお示しいたしますので、担当コンサルタントまでお気軽にご相談ください。'
  },
  {
    cate: '受講期間',
    q: '休会はできますか？',
    a: `休会制度はございませんが、ご受講が難しい週はセッションのお振替が可能です。担当コンサルタントにご相談ください。`
  },
  {
    cate: 'サポート',
    q: 'メールやStudyplusで学習に関して質問した場合、すぐに返信をもらえますか？',
    a: `いただいたご質問につきましては、原則翌営業日までに担当コンサルタントからご返信いたします。担当コンサルタントがお休みをいただいている場合、他のコンサルタントがご返信することもございます。`
  },
  {
    cate: 'サポート',
    q: 'コンサルティングレポートはいつ届きますか？',
    a: 'コンサルティングセッション終了後、翌日15時までにお送りいたします。Studyplus の通知を許可していただくと、配信の際にお知らせが表示されます。'
  },
  {
    cate: '支払い',
    q: '領収書は発行可能ですか？',
    a: '発行可能でございます。<br />領収書発行をご希望の場合、宛名、但書に指定がございます場合には併せてお知らせくださいませ。<br />特にご希望がない場合には、弊社規定のものでご用意いたします。'
  },
  {
    cate: '支払い',
    q: '受講料の支払いにクレジットカードは使用できますか？',
    a: '申し訳ございませんが、クレジットカードはお取り扱いしておりません。'
  },
  {
    cate: '支払い',
    q: '受講料の支払いを上限の関係で2回に分けて振り込むことは可能ですか？',
    a: '可能です。事前にLINEもしくはメールにてご連絡いただけますと、お手続きがスムーズに進みますので、ご協力のほどお願いいたします。'
  },
  {
    cate: 'オンライン',
    q: '教材はどのように受け取れますか？',
    a: `初回コンサルティングセッションまでにヤマト運輸にてお送りいたします。<br />
        日付のご指定ができませんので、万が一お受け取りできなかった場合は、お手数ですが不在票などで再配達のご依頼をお願いいたします。`
  },
  {
    cate: 'オンライン',
    q: '契約書は郵送ですか？データですか？',
    a: '教材とは別でレターパックにてご郵送いたします。ポスト投函となりますので、初回コンサルティングセッションまでに内容のご確認と、お手数ですが必要書類のご返送をお願いいたします。'
  },
  {
    cate: 'オンライン',
    q: 'スマートフォンでもオンライントレーニングセッションの受講は可能ですか？',
    a: 'PCやタブレットなどでのご受講を推奨しておりますが、スマートフォンでのご受講も可能です。但しコンサルティング中に画面を共有した際、教材やコンサルタントの顔が見え難い場合がございますので予めご了承願います。'
  },
  {
    cate: 'その他',
    q: '自習時間はどれくらい確保する必要がありますか？',
    a: '皆さまのライフスタイルや学習の進捗にあわせて、都度コンサルタントがアドバイスさせていただきますが、目に見える成果を比較的短期間で出していただくためにも、毎日1時間程度以上の学習時間をとっていただくことをおすすめしております。'
  },
  {
    cate: 'その他',
    q: '自習スペースは利用可能ですか？',
    a: `2021年よりスタジオのバーチャル化を行いまして、オンラインでのご受講が中心となっております。そのため通常自習スペースは解放しておりませんが、ご利用いただける可能性もございますので、事前にご相談いただけますと幸いです。`
  },
  {
    cate: 'その他',
    q: 'コンサルティング期間終了後に、継続できるプランがあれば教えてください。',
    a: `・コンサルティング期間の延長（1ヶ月単位での延長が可能）<br />
        ・ENGLISH COMPANY MOBILE（トレーニング教材配信ウェブサービス）<br />
        ・上級グループトレーニングコース<br />

        などがございます。<br />
        卒業時期が近づいてきましたら、その時点での課題や習熟度、先々の学習プランニングも含めて、担当コンサルタントより最適なプランニングをご提案させていただきます。`
  },
  {
    cate: 'その他',
    q: '修了証は発行可能ですか？',
    a: '発行可能でございます。書面、もしくはPDFいずれかでの発行となりますので、ご希望の場合は所属スタジオの受付担当者にお申し付けください。'
  },
]